import React, { useState } from "react";
import { Check } from "react-feather";
import NewButton from "./NewButton";
import "./PopUpModal.css";

const RejectTranslation = ({ files, onCancelClick, onRejectClick }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Toggle file selection
  const handleCheck = (file) => {
    setSelectedFiles((prev) =>
      prev.includes(file) ? prev.filter((f) => f !== file) : [...prev, file]
    );
  };

  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer max-w-[50vw]">
        <h2 className="newPopUpModalTitle">Reject Translation</h2>
        <div className="newPopUpModalContent w-full">
          <div className="newPopUpModalTextWrap">
            {files.length > 0 ? (
              <div className="fileList w-full">
                {files.map((file) => (
                  <div key={file.name} className="hardCopyCheckboxLine">
                    <div
                      className={`${
                        selectedFiles.includes(file) ? "hardCopyChecked" : ""
                      } hardCopyCheckbox`}
                    >
                      <Check
                        className="hardCopyCheck"
                        onClick={() => handleCheck(file)}
                        style={{ opacity: selectedFiles.includes(file) ? 1 : 0 }}
                      />
                    </div>
                    <p
                      className="hardCopyCheckboxText"
                      onClick={() => handleCheck(file)}
                    >
                      {file.name}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p>No translated files available.</p>
            )}
          </div>
        </div>
        <div className="flex w-full gap-2">
          <div className="w-full">
            <NewButton text={"Cancel"} width="100%" onClick={onCancelClick} back icon={false} whiteBtn />
          </div>
          <div className="w-full">
            <NewButton
              text={"Reject Translation"}
              width="100%"
              onClick={() => onRejectClick(selectedFiles)}
              disabled={selectedFiles.length === 0} // Disable if no files selected
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectTranslation;
